import { createFileRoute } from "@tanstack/react-router";
import { WechatServiceAccountPage } from "@/features/admin/wechat-service-account/wechat-service-account-page";

export const Route = createFileRoute("/admin/wechat-service-account")({
  staticData: {
    title: "微信服务号",
  },
  ssr: false,
  component: RouteComponent,
});

function RouteComponent() {
  return <WechatServiceAccountPage />;
}
